import { render, staticRenderFns } from "./SplitPack.vue?vue&type=template&id=535166ab&scoped=true&"
import script from "./SplitPack.vue?vue&type=script&lang=js&"
export * from "./SplitPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535166ab",
  null
  
)

export default component.exports